<template>
<div >
  <div class="Serve-container">
    <div class="Serve-title">核心能力</div>
    <div class="Serve-list">
       
        <div class="list-item" v-for="(it,index) in list" :key="index">
            <img class="logo" :src="it.img" alt="">
            <p class="item-title">{{it.title}}</p>
            <p class="item-content">{{it.content}}</p>
        </div>

    </div>
  </div>


   <div class="Serve-container">
    <div class="Serve-title">合作伙伴</div>
    <div class="Serve-list">
       
        <div class="enterprise-grid">
            <div class="enterprise-item" v-for="(it,index) in enterpriseList" :key="index">
                <p class="enterprise-name" @click=handele(it)>{{it}}</p>
            </div>
        </div>
    </div>
  </div>
  </div>
</template>

<script>
import img1 from "@/assets1/首页-未登录_slices/位图(2).png" 
import img2 from "@/assets1/首页-未登录_slices/位图(3).png" 
import img3 from "@/assets1/首页-未登录_slices/位图(4).png" 
export default {

data(){
    return{
        enterpriseList:['四川雄富蕊能科技有限公司','四川明泰微电子有限公司','四川绿建杭萧钢构有限公司','内江筑石混凝土有限公司','四川乐鸿科技有限公司','内江建工远大建筑科技有限公司','中建材凯盛机器人四川有限公司','长川科技（内江）有限公司','内江路桥新型材料有限公司','四川绿建装配式钢结构有限公司','内江多普勒科技有限公司','四川奥达测控装置有限公司','内江盛科达钢结构有限公司','内江威士凯电子有限公司','晶益通（四川）半导体科技有限公司','四川乾瑞电子科技有限公司','内江国星空天科技有限公司','佰奥智能装备（内江）有限公司','博泰车联网（内江）有限公司','四川晶导微电子有限公司','东微电子（内江）有限公司','四川虹鹰动力科技有限公司','景焱（四川）半导体设备有限公司','四川省停碳科技有限公司','四川文图跃迁科技发展有限公司','内江镭明半导体制造有限公司','内江数循数字科技有限公司'],
        list:[{
            title:'多维度海量数据',
            content:'包含全球典型的开放数据资源案例，覆盖12大垂直行业，文本、图片、音频、视频、3D等多种数据类型',
            img:img1
        },

        {
            title:'区块链技术',
            content:'使用区块链技术实现可信传输和数据资源存证，保护数据所有者的权益.',
            img:img2
        },
        {
            title:'支持定制化',
            content:'提供定制化数据资源方案',
            img:img3
        }
        ]
    }
},
methods:{
    handele(it){
        if (it === '内江数循数字科技有限公司') {
            window.open('https://njsx.cn', '_blank');
        }
    }
}


}
</script>

<style scoped>
.Serve-title{
    /* margin-top: 40px;
      
    font-size:33px ;
    font-weight: 500; */
color: #fff;
font-family: Medium;
font-weight: 500;
font-size: 36px;

font-style: normal;
margin-bottom: 60px;
}
.logo{
    width: 80px;
    height: 80px;
    object-fit: cover;
    /* margin: 0 auto; */
}
.Serve-container{
padding-top: 100px;
min-width: 1200px;
padding-bottom: 80px;
background-repeat: no-repeat;
background-image: url('https://sxoffcia.oss-cn-chengdu.aliyuncs.com/offcia_Img/%E6%95%B0%E6%8D%AE%E9%9B%86%E8%B6%85%E5%B8%82%E4%BB%8B%E7%BB%8D%E9%A1%B5/%E4%BD%8D%E5%9B%BE%281%29.png');
background-size: cover;
background-position: center;
text-align: center;
}
.Serve-list{
    display: flex;
    justify-content: center;
}
.Serve-list:has(.enterprise-grid) {
    display: block;
}
.list-item{
    width: 360px;

    display: flex;
    flex-direction: column;
    /* justify-content: center; */
    align-items: center;
    text-align: center;
    padding: 0 20px;
}
.item-title{
    /* margin-top: 20px;
    font-size: 15px;
    font-weight: 500;
    margin-bottom: 10px; */
    margin-top: 40px;
     margin-bottom: 15px;
font-family: Medium;
font-weight: 500;
font-size: 18px;
color: #fff;
line-height: 25px;

font-style: normal;
}
.item-content{
    font-family: Regular;

    font-size: 15px;
  color: rgba(255, 255, 255, .6);
     letter-spacing:1px;
}

/* 合作伙伴企业列表样式 */
.enterprise-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 20px 30px;
    max-width: 1400px;
    margin: 0 auto;
    padding: 0 40px;
}

.enterprise-item {
    background: rgba(255, 255, 255, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 8px;
    padding: 16px 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;
}

.enterprise-item:hover {
    background: rgba(255, 255, 255, 0.2);
    border-color: rgba(255, 255, 255, 0.4);
    transform: translateY(-2px);
}

.enterprise-name {
    color: #fff;
    font-family: Regular;
    font-size: 14px;
    text-align: center;
    margin: 0;
    line-height: 1.5;
}
</style>